import Requests from "@/services/Requests";

const state = {
  specialDiscounts: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allSpecialDiscounts: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  specialDiscountById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of specialDiscounts based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter specialDiscounts by. Defaults to 0.
   * @return {Array} An array of specialDiscounts filtered by the given page number. If page is 0, returns all specialDiscounts.
   */
  getSpecialDiscounts:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.specialDiscounts.data
        : state.specialDiscounts.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllSpecialDiscounts: (state) => state.allSpecialDiscounts.data,
  getSpecialDiscountStatus: (state) => state.specialDiscounts.status,
  getSpecialDiscountCount: (state) => state.specialDiscounts.count,
  getSpecialDiscountPage: (state) => state.specialDiscounts.page,
  getSpecialDiscountsLoading: (state) =>
    state.specialDiscounts.status === "loading",
  getSpecialDiscountById: (state) => (id) =>
    state.specialDiscountById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the specialDiscount in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the specialDiscount.
   */
  SET_SPECIAL_DISCOUNT_STATUS(state, payload) {
    console.log(state.specialDiscounts, "status: ", payload);
    state.specialDiscounts.status = payload;
  },
  /**
   * Sets the specialDiscounts and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload - The array of specialDiscounts.
   */
  SET_SPECIAL_DISCOUNTS(state, payload) {
    state.specialDiscounts.data = payload.items;
    state.specialDiscounts.count = payload.count;
  },
  /**
   * Sets the specialDiscounts and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload - The array of specialDiscounts.
   */
  SET_ALL_SPECIAL_DISCOUNTS(state, payload) {
    console.log("SET_ALL_SPECIAL_DISCOUNTS", payload);
    state.allSpecialDiscounts.data = payload;
    state.allSpecialDiscounts.count = payload.length;
  },
  /**
   * Updates the status of the update specialDiscount in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the specialDiscount.
   */
  SET_UPDATE_SPECIAL_DISCOUNT_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an specialDiscount object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated specialDiscount object.
   * @return {void}
   */
  SET_UPDATE_SPECIAL_DISCOUNT(state, payload) {
    const index = state.specialDiscounts.data.findIndex(
      (d) => d.id === payload.id
    );
    const specialDiscount = state.specialDiscounts.data[index];
    state.specialDiscounts.data[index] = { ...specialDiscount, ...payload };
  },
  SET_CREATE_SPECIAL_DISCOUNT_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new specialDiscount to the list of specialDiscounts in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The specialDiscount object to be added.
   * @return {void}
   */
  SET_CREATE_SPECIAL_DISCOUNT(state, payload) {
    state.specialDiscounts.data.push(payload);
  },
  /**
   * Updates the status of the delete specialDiscount in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the specialDiscount.
   */
  SET_DELETE_SPECIAL_DISCOUNT_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an specialDiscount from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the specialDiscount ID to be deleted.
   * @param {number} payload.id - The ID of the specialDiscount to be deleted.
   * @return {void}
   */
  SET_DELETE_SPECIAL_DISCOUNT(state, payload) {
    state.specialDiscounts.data = state.specialDiscounts.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_SPECIAL_DISCOUNT_BY_ID_STATUS(state, payload) {
    state.specialDiscountById.status = payload;
  },
  SET_SPECIAL_DISCOUNT_BY_ID(state, payload) {
    state.specialDiscountById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of specialDiscounts based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.searchKey - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getSpecialDiscounts({ commit, state }, payload) {
    const status = state.specialDiscounts.status;
    commit("SET_SPECIAL_DISCOUNT_STATUS", "loading");
    const response = await Requests.SpecialDiscount.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_SPECIAL_DISCOUNTS", {
        items: response.data.map((item) => ({
          ...item,
          page: payload.query.page,
        })),
        count: response.data.length,
      });
      console.log(payload, "payload", payload.initial, "inital");
      if (status === "unitiliazed")
        commit("SET_ALL_SPECIAL_DISCOUNTS", {
          items: response.data.map((item) => ({
            ...item,
            page: payload.query.page,
          })),
          count: response.data.count,
        });
    }
    commit("SET_SPECIAL_DISCOUNT_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an specialDiscount by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the specialDiscount data.
   * @param {string} payload.fullName - The full name of the specialDiscount.
   * @param {string} payload.phoneNumber - The phone number of the specialDiscount.
   * @param {string} payload.email - The email of the specialDiscount.
   * @param {string} payload.regionId - The ID of the region the specialDiscount belongs to.
   * @param {File} payload.image - The image of the specialDiscount.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createSpecialDiscount({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.SpecialDiscount.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_SPECIAL_DISCOUNT", {
          id: response.data,
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          email: payload.email,
          regionId: payload.regionId,
          image: payload.image,
          workStartTime: payload.workStartTime,
          workEndTime: payload.workEndTime,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an specialDiscount by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the specialDiscount data to update.
   * @param {string} payload.fullName - The full name of the specialDiscount.
   * @param {string} payload.phoneNumber - The phone number of the specialDiscount.
   * @param {string} payload.email - The email of the specialDiscount.
   * @param {string} payload.regionId - The ID of the region the specialDiscount belongs to.
   * @param {File} payload.image - The image of the specialDiscount.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @param {boolean} payload.isActive - Whether the specialDiscount is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateSpecialDiscount({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.SpecialDiscount.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_SPECIAL_DISCOUNT", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
    } catch {
      state.updateStatus = "error";
    }
  },
  /**
   * Removes an specialDiscount from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the specialDiscount data.
   * @param {number} payload.id - The ID of the specialDiscount to be removed.
   * @returns {Promise<void>} A promise that resolves when the specialDiscount is successfully removed.
   */
  removeSpecialDiscount({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.SpecialDiscount.Delete({ params: { id } })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
        return response;
      })
      .catch(() => {
        state.deleteStatus = "error";
        return { message: "ERROR" };
      });
  },
  /**
   * Retrieves an specialDiscount by their ID and updates the specialDiscount by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the specialDiscount to retrieve.
   * @return {Promise} A promise that resolves when the specialDiscount is successfully retrieved and the status is updated.
   */
  getSpecialDiscountById({ commit, state }, { id }) {
    // check if specialDiscount already exists in the state;
    if (
      state.specialDiscountById.data.find(
        (specialDiscount) => specialDiscount.id === id
      )
    )
      return;
    commit("SET_SPECIAL_DISCOUNT_BY_ID_STATUS", "loading");
    return Requests.SpecialDiscount.GetById({ params: { id } })
      .then((response) => {
        commit("SET_SPECIAL_DISCOUNT_BY_ID", response.data);
        commit("SET_SPECIAL_DISCOUNT_BY_ID_STATUS", "success");
      })
      .catch(() => {
        commit("SET_SPECIAL_DISCOUNT_BY_ID_STATUS", "error");
      });
  },
};

export default { state, getters, mutations, actions };
